import { toDiv } from "../../utils";
import { StreamCoordinates } from "./interface";

export class StreamBadge {
  static STREAM_BADGE_HEIGHT = 40;
  static STREAM_BADGE_MAX_WIDTH = 1280;

  private static STREAM_BADGE_HEIGHT_SCALE_FACTOR = 0.1;
  private static MIN_STREAM_BADGE_HEIGHT = 20;
  private static MAX_STREAM_BADGE_HEIGHT = 40;

  static streamBadgeHeight(streamCoordinates: StreamCoordinates) {
    const streamBadgeHeight0 = toDiv(
      streamCoordinates.height * StreamBadge.STREAM_BADGE_HEIGHT_SCALE_FACTOR,
      8
    );
    const streamBadgeHeight1 =
      streamBadgeHeight0 > StreamBadge.MAX_STREAM_BADGE_HEIGHT
        ? StreamBadge.MAX_STREAM_BADGE_HEIGHT
        : streamBadgeHeight0;

    return streamBadgeHeight1 < StreamBadge.MIN_STREAM_BADGE_HEIGHT
      ? StreamBadge.MIN_STREAM_BADGE_HEIGHT
      : streamBadgeHeight1;
  }
}
